// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1mUHg","messages":"Chat_messages__14Z8d","dateDivider":"Chat_dateDivider__3Hd0s"};